import { useSearch } from '@tanstack/react-router';

import { AdminStatisticsMessage } from '../../../types/StatisticsMessage';

import { CustomersTabContent } from './CustomersTabContent';
import { GeneralTabContent } from './GeneralTabContent';
import { PortsTabContent } from './PortsTabContent';
import { ProductGroupsTabContent } from './ProductGroupsTabContent';
import { ProductsTabContent } from './ProductsTabContent';
import { StatisticTab } from './StatisticTab';
import { SuppliersTabContent } from './SuppliersTabContent';
import { VesselsTabContent } from './VesselsTabContent';

interface AdminStatisticsContentProps {
    statistics: AdminStatisticsMessage;
}

interface AdminStatisticsSearch {
    tab: StatisticTab;
}

export const AdminStatisticsContent = ({ statistics }: AdminStatisticsContentProps) => {
    const search: AdminStatisticsSearch = useSearch({ from: '/_app/statistics' });

    switch (search.tab) {
        case StatisticTab.GENERAL:
            return <GeneralTabContent statistics={statistics} />;
        case StatisticTab.VESSELS:
            return <VesselsTabContent vesselStatistics={statistics.vessel} />;
        case StatisticTab.SUPPLIERS:
            return <SuppliersTabContent supplierStatistics={statistics.supplier} />;
        case StatisticTab.CUSTOMERS:
            return <CustomersTabContent customerStatistics={statistics.customer} />;
        case StatisticTab.PORTS:
            return <PortsTabContent portStatistics={statistics.port} />;
        case StatisticTab.PRODUCTS:
            return <ProductsTabContent productStatistics={statistics.product} />;
        case StatisticTab.PRODUCT_GROUPS:
            return <ProductGroupsTabContent productGroupsStatistics={statistics.productGroup} />;
    }
};
